import EdsCModal from '@springernature/elements/components/eds-c-modal/js/eds-c-modal.js';

/**
 * Initializes modal video functionality.
 * Pauses all videos when any modal is opened or closed.
 * @module Modal Video
 */
export default function modalVideo() {
	const modalElements = document.querySelectorAll('[data-component-modal]');
	const videos = document.querySelectorAll('video');

	if (modalElements && videos) {
		for (const modalElement of modalElements) {
			const exampleModal = new EdsCModal(modalElement);

			/**
			 * Overrides the open method to pause all videos before opening the modal.
			 */
			exampleModal.open = function () {
				for (const video of videos) {
					video.pause();
				}
				EdsCModal.prototype.open.call(this);
			};

			/**
			 * Overrides the close method to pause all videos before closing the modal.
			 */
			exampleModal.close = function () {
				for (const video of videos) {
					video.pause();
				}
				EdsCModal.prototype.close.call(this);
			};
		}
	}
}
